<script>
import CheckboxField from '@phoenix/mixins/components/form/fields/CheckboxField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [CheckboxField],

  setup(props) {
    return useField(props);
  },
};
</script>

<template>
  <input
    :id="fieldUniqueId"
    v-model="value"
    :name="field.name"
    :aria-describedby="ariaDescribedby"
    type="checkbox"
    class="switch"
    :data-cy="$attrs['data-cy']"
  />
  <label :for="fieldUniqueId" class="label rich-text" v-html="field.label" />
</template>
